module.exports = __webpack_public_path__ + "static/app_hint_download-adf4db7ea88b1326a21d841759d124d1.png";